<script>
  // @ts-check
  import Grid from "../../atoms/Grid.svelte";
  import { getContext } from "svelte";
  import ListItem from "./ListItem.svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = undefined;

  /**
   * Number of columns, inset is for 2 and fullWidth 4
   * @type {"inset" | "fullWidth"}
   */
  export let columnsVariant = "fullWidth";

  if (getContext("CenteredLayout")) {
    columnsVariant = "inset";
  }

  /**
   * Variant to display ordered(w/ numbers) list or unordered list
   * @type {"unordered" | "ordered"}
   */
  export let variant = "unordered";

  /**
   * Array of ListItems
   * @type {ListItemType[]}
   */
  export let data = [];

  // const gridClass = columnsVariant === "fullWidth" ? "" : "md:grid-cols-8 lg:grid-cols-6";
  const subGridColumns =
    columnsVariant === "fullWidth"
      ? null
      : /** @type {const} **/ ({ mobile: 4, tablet: 8, desktop: 6 });
  const listItemClass =
    columnsVariant === "fullWidth" ? "md:odd:col-start-3 lg:odd:col-start-auto" : "md:col-span-3";
</script>

<div {id} class={className}>
  <Grid
    {subGridColumns}
    gridElement={variant === "ordered" ? "ol" : "ul"}
    gridClass=" gap-y-7.5 md:gap-y-15 lg:gap-y-20 xl:gap-y-25"
  >
    {#each data as { headline, body, component, componentProps }, index (index)}
      <li
        class="col-full-width border-t-thin pt-6 md:col-span-4 lg:col-span-3 xl:pt-7.5 {listItemClass}"
      >
        <ListItem label={headline} number={variant === "ordered" ? index + 1 : undefined}>
          {#if component}
            <svelte:component this={component} {...componentProps} />
          {:else if !!body}
            {body}
          {/if}
        </ListItem>
      </li>
    {/each}
  </Grid>
</div>
